/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/switcher-circle-icon': {
    width: 16,
    height: 16,
    viewBox: '0 0 52 47',
    data: '<path pid="0" class="switcher-circle-icon--left" d="M28.17 0A2.16 2.16 0 0026 2.14v42.72A2.16 2.16 0 0028.17 47 23.67 23.67 0 0052 23.5 23.67 23.67 0 0028.17 0z"/><path pid="1" class="switcher-circle-icon--right" d="M23.83 47A2.16 2.16 0 0026 44.86V2.14A2.16 2.16 0 0023.83 0 23.67 23.67 0 000 23.5 23.67 23.67 0 0023.83 47z"/>'
  }
})
